module.exports = __webpack_public_path__ + "images/CeramicEcosystemMappingReport.pdf?v=148e8cf9c1cb2a4af881bc007e49a6cf";